var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.option)?_c('div',{staticClass:"issue_status"},[_c('IssueIcon',{attrs:{"type":_vm.option._id}}),_c('div',[_vm._v(_vm._s(_vm.option.value))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }